import { StyleProps } from '../../types';
import { stylePropKeys } from '../styleProps';

/**
 * Separates props passed to a component into the following categories:
 *
 * - Token props: CSS-conformant token properties allowed by the design system.
 * - Other props: Everything else not matching our token properties.
 */
export function filterTokenProps(props: Record<string, any>): {
  tokenProps: StyleProps;
  restProps: Record<string, any>;
} {
  const tokenProps: Record<string, any> = {};
  const restProps: Record<string, any> = {};

  Object.keys(props).forEach((key) => {
    if (stylePropKeys[key as keyof typeof stylePropKeys]) {
      tokenProps[key] = props[key];
    } else {
      restProps[key] = props[key];
    }
  });

  return { tokenProps, restProps };
}
